const EMPTY_ARRAY = [];
const EMPTY_OBJECT = {};

export default {
  EMPTY_ARRAY,
  EMPTY_OBJECT,
};
